import type { AppModule } from '@/types/architecture'
import routes from './routes'

/**
 * Users Module - User Management
 * 
 * Manages users within the current organization.
 * Accessible to admin and member roles.
 */
const usersModule: AppModule = {
    id: 'users',
    navigation: {
        label: 'Users',
        icon: 'users',
        path: '/users',
        order: 3,
        moduleKey: 'settings.users',
        showInSidebar: false, // Accessed via Settings navigation group
        pages: [
            {
                label: 'All Users',
                path: '/users',
                icon: 'users',
            },
            {
                label: 'Add User',
                path: '/users/create',
                icon: 'user-plus',
            },
        ],
    },
    routes,
}

export default usersModule
